import { createHttpClient } from "./http";

export class ProdutoRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async getAll(unidadeDistribuidoraId, tipo) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (tipo) {
				params.tipo = tipo;
			}

			const result = await this.axios.get("produto-unidade-distribuidora", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao listar produtos.");
		}
	}

	async getEmbalagens(produtoId) {
		try {
			const result = await this.axios.get("produto-unidade-distribuidora/embalagens", {
				params: { produtoId },
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao buscar embalagens.");
		}
	}
}
